import { createContext } from 'react';
import { UiStateWithFunctions } from './interface';
import { initialUiStateWithFunctions } from './initialState';

const UIContext = createContext<UiStateWithFunctions>(initialUiStateWithFunctions);
UIContext.displayName = 'UIContext';

export default UIContext;
